/** Sivir AbilitySpec seed kit. */
export const SIVIR_ABILITY_DEFS = [
  {
    id: 'sivir_q',
    champKey: 'sivir',
    slot: 'Q',
    name: 'Boomerang Blade',
    targeting: 'skillshot_line',
    range: 1250,
    castTime: 0.25,
    travelSpeed: 1450,
    width: null,
    radius: 16,
    cooldown: 10,
    manaCost: 55,
    vfxId: 'sivir_q',
    isBoomerang: true,
    status: 'wired'
  },
  {
    id: 'sivir_w',
    champKey: 'sivir',
    slot: 'W',
    name: 'Ricochet',
    targeting: 'self_buff',
    range: 500,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 12,
    manaCost: 60,
    vfxId: 'sivir_w',
    status: 'wired'
  },
  {
    id: 'sivir_e',
    champKey: 'sivir',
    slot: 'E',
    name: 'Spell Shield',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 24,
    manaCost: 50,
    vfxId: 'sivir_e',
    status: 'wired'
  },
  {
    id: 'sivir_r',
    champKey: 'sivir',
    slot: 'R',
    name: 'On the Hunt',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 120,
    manaCost: 100,
    vfxId: 'sivir_r',
    duration: 8,
    status: 'wired'
  }
];
